/**
 * Words and dates of the document toolbar and author line (cards 2.1, 2.3).
 * Pure: `t` and the language come in, so tests run without i18n.
 */

/** Words in a saved body: tags dropped, entities decoded, runs of letters/digits counted. */
export function countWords(bodyHtml) {
  const html = String(bodyHtml || '');
  if (!html) return 0;
  const text = html
    .replace(/<(br|\/p|\/h[1-6]|\/li|\/div|\/td|\/th|\/blockquote|\/pre)[^>]*>/gi, ' ')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&[a-z#0-9]+;/gi, 'x');
  const words = text.match(/[\p{L}\p{N}][\p{L}\p{N}'’_-]*/gu);
  return words ? words.length : 0;
}

/** "just now" / "5 min ago" / "3 h ago" / "4 d ago" / a date past 30 days. */
export function relativeAge(ms, now, t, lang) {
  if (!Number.isFinite(ms)) return null;
  const s = Math.max(0, Math.round((now - ms) / 1000));
  if (s < 60) return t('docEditor.meta.justNow');
  if (s < 3600) return t('docEditor.meta.minutesAgo', { count: Math.floor(s / 60) });
  if (s < 86400) return t('docEditor.meta.hoursAgo', { count: Math.floor(s / 3600) });
  // Days round to the nearest (3 d 17 h reads "4 d ago", like the sidebar's ages).
  if (s < 30 * 86400) return t('docEditor.meta.daysAgo', { count: Math.max(1, Math.round(s / 86400)) });
  return formatDay(ms, lang);
}

/** "28 Sep 2026" (day, short month, year — in the UI language). */
export function formatDay(ms, lang = 'en') {
  if (!Number.isFinite(ms)) return '';
  const d = new Date(ms);
  let month;
  try {
    month = new Intl.DateTimeFormat(lang, { month: 'short' }).format(d);
  } catch {
    month = new Intl.DateTimeFormat('en', { month: 'short' }).format(d);
  }
  return `${d.getDate()} ${month} ${d.getFullYear()}`;
}

/** 1240 → "1,240" (en) / "1.240" (de). */
export function formatCount(n, lang = 'en') {
  try {
    return new Intl.NumberFormat(lang).format(n);
  } catch {
    return String(n);
  }
}
